<template>
  <div class="wapper">
    <div class="banner">
      <van-image width="92%" height="140" :src="iamge1" />
    </div>
    <h3 class="middleP">培训课程</h3>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <van-cell
        v-for="(item, index) in listData"
        :key="index"
        @click="toTrainDetail(item.id)"
      >
        <div>
          <van-image
            style="float: left"
            width="60"
            height="60"
            :src="iamge2"
          />
          <div class="cellMiddle">
            <p class="trainName">{{ item.trainName }}</p>
            <p class="name">{{ item.trainMode }}</p>
          </div>
          <div class="cellRight">￥{{ item.trainCost }}/人次</div>
        </div>
      </van-cell>
    </van-list>
    <!-- <div class="container "> </div> -->
  </div>
</template>

<script>
import { Button, Image, List, Cell } from 'vant'
import api from '@/api'
import Vue from "vue";

export default {
  components: {
    [Button.name]: Button,
    [Image.name]: Image,
    [List.name]: List,
    [Cell.name]: Cell,
  },

  data() {
    return {
      iamge1: require('../../assets/img/banner.png'),
      iamge2: require('../../assets/img/title3.png'),
      listData: [],
      loading: false,
      finished: false
    };
  },

  methods: {
    onLoad() {
      this.getList();

      this.loading = false;
      this.finished = true;
    },
    async getList() {
      const param = {}
      const res = await api.train.getTrainIng(param);
      if (res.msg === 'success') {
        this.listData = [...this.listData, ...res.data];
        this.totalPage = res.totalPage;
        setTimeout(()=> {
          this.loading = false;
        },10)
      }
    },
    toTrainDetail(item) {
      let $trainInfo = {
        trainId: item
      }
      Vue.prototype.$trainInfo = $trainInfo;
      this.$router.push({
        name: 'trainDetail',
        // path: '/trainDetail',
        query: {
          trainId: item
        }
      });
    },
  
  }
};
</script>

<style lang="less" scoped>
.container{
  width:100%;
  height:5rem;
}
.wapper {
  background: #fff;
  .banner {
    display: flex;
    justify-content: center;
    margin-top: 1rem;
    
  }
}
.middleP {
  margin-top: 1rem;
  margin-bottom: 1rem;
  height: 1rem;
  font-size: 4vw;
  margin-left: 1rem;
  font-weight: 800;
  color: #222222;
  line-height: 1rem;
}
.cellMiddle {
  float: left;
  position: relative;
  font-size: 4.5333vw;
  // font-weight: bold;
  margin-left: 1rem;
  margin-bottom: 0.5rem;
  // line-height: 2rem;
  .trainName{
  width: 67.999983vw;
  height: 6.3999984vw;
  display: block;
  // overflow-wrap: break-word;
  color: rgba(34, 34, 34, 1);
  font-size: 4.5333322vw;
  text-overflow: ellipsis; 
  white-space: nowrap;
  overflow: hidden;
  line-height: 6.3999984vw;
  margin-bottom: 3.9vw;
  }
  .name {
    font-size: 0.7rem;
    color: #999999;
    // margin-top: 2vw;
    // position: absolute;
  }
}
.cellRight {
  position: absolute;
  font-size: 0.7rem;
  right: 0rem;
  bottom: 0.5rem;

  color: #faa105;
}
</style>
